import React from 'react'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography';
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { DynamicTicketTextItem } from './dynamictickettextitem'


export const TicketCalled = ({ticket, successtext, meetuptext, infotext, dynamicinfotext}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.container}>
        <Paper elevation={0} className={[classes.semicontainer, "ticket-semicontainers"].join(' ')} id="ticket-called-semicontainer-1">
          <Typography
            align="center"
            variant="h3"
            className={[classes.title, "ticket-titles"].join(' ')}
            id="ticket-called-text-id"
          >
            { successtext || "Det är din tid nu!" }
          </Typography>
          <Typography
            align="center"
            variant="h1"
            className={[classes.valuetext, "ticket-valuetexts"].join(' ')}
            id="ticket-called-valuetext-id"
          >
            { ticket.ticketnumber}
          </Typography>
          <Typography
            align="center"
            variant="subtitle1"
            className={[classes.timestamptext, "ticket-timestamp-texts"].join(' ')}
            id="ticket-called-timestamp-text-id"
          >
          { ticket.timestamp}
        </Typography>
        </Paper>
        <Paper elevation={0} className={[classes.semicontainer, "ticket-semicontainers"].join(' ')} id="ticket-called-semicontainer-2">
          <Typography
            align="center"
            variant="h3"
            className={[classes.title, "ticket-titles"].join(' ')}
            id="ticket-meetup-text-id"
          >
            { meetuptext || "Gå till plats "}
          </Typography>
          <Typography
            align="center"
            variant="h1"
            className={[classes.valuetext, "ticket-valuetexts"].join(' ')}
            id="ticket-meetup-valuetext-id"
          >
            { ticket.meetUpLocation }
          </Typography>
        </Paper>
        <Box className={classes.infotextcontainer} id="ticket-infotextcontainer-id">
          <Typography className="ticket-infotext">{ infotext }</Typography>
          { dynamicinfotext ? dynamicinfotext.map(x => { return <DynamicTicketTextItem label={x.label} text={x.value} />}) : <span/> }
        </Box>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles({
  container: theme => ({
    backgroundColor: theme.palette.background.main,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    position: 'relative',
    alignItems: 'center',
    overflow: 'auto'
  }),
  wrapper: {
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%',
    overflow: 'auto'
  },
  semicontainer: theme => ({
    minWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '80%',
    borderRadius: '20px',
    backgroundColor: theme.palette.ticket_called.main,
    margin: '10px 0',
    padding: '0 0.5rem 0.5rem 0.5rem'
  }),
  title: theme => ({
    color: theme.palette.secondary_text.main,
    marginTop: '0.5rem'
  }),
  valuetext: theme => ({
    color: theme.palette.button_text.main,
    fontSize: '4rem',
    fontWeight: '900',
    [theme.breakpoints.down('xs')]: {
      fontSize: '3rem' 
     }
  }),
  timestamptext: theme => ({
    color: theme.palette.secondary_text.main,
    fontSize: 'small'
  }),
  infotextcontainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '300px',
    maxWidth: '80%'
  }
})